import {useEffect, useState} from 'react'

import jsCookie from '@s-ui/js/lib/cookie'

export const useCooldownAppSuggestion = ({cookieName}) => {
  const [allowRenderBasedOnCooldown, setAllowRenderBasedOnCooldown] = useState(false)

  const setCooldownPeriod = hours => {
    const currentTime = new Date().getTime()
    const expirationTimestamp = currentTime + hours * 60 * 60 * 1000

    const cooldownData = {
      timestamp: currentTime,
      expirationTimestamp
    }

    jsCookie.set(cookieName, JSON.stringify(cooldownData), {expires: 30})
  }

  const clearCooldownData = () => {
    jsCookie.remove(cookieName)
  }

  useEffect(() => {
    if (typeof window === 'undefined') return

    const checkCooldown = async () => {
      try {
        const cooldownCookie = await jsCookie.get(cookieName)

        if (!cooldownCookie) {
          setAllowRenderBasedOnCooldown(true)
          return
        }

        const {expirationTimestamp} = JSON.parse(cooldownCookie)
        const currentTime = new Date().getTime()

        if (currentTime > expirationTimestamp) {
          setAllowRenderBasedOnCooldown(true)
          clearCooldownData()
        } else {
          setAllowRenderBasedOnCooldown(false)
        }
      } catch (error) {
        setAllowRenderBasedOnCooldown(true)
        clearCooldownData()
        console.error('Error checking app suggestion cooldown', error)
      }
    }

    checkCooldown()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return {
    setCooldownPeriod,
    setAllowRenderBasedOnCooldown,
    allowRenderBasedOnCooldown
  }
}
